module.exports = __webpack_public_path__ + "static/media/phone.431daa73.svg";